import omit from 'lodash/fp/omit';
import type { UserProfile as Profile } from 'oidc-client-ts';

import type { UserProfile } from './loginSlice';

const stripSnakeProps = omit(['family_name', 'given_name', 'client_id']);

export const mapUserProfile = (profile: Profile): UserProfile => ({
    sub: profile.sub,
    azp: profile.azp,
    givenName: profile.given_name,
    familyName: profile.family_name,
    name: profile.name,
    locale: profile.locale,
    email: profile.email,
    tenant: typeof profile.tenant === 'string' ? profile.tenant : undefined,
    logisticsTenant: typeof profile.logistics_tenant === 'string' ? profile.logistics_tenant : undefined,
    ...stripSnakeProps(profile),
});
